// extracted by mini-css-extract-plugin
export default {"text":"freeShipping_text__lBcUD","progress":"freeShipping_progress__cS3ps","track":"freeShipping_track__4wRGJ"};